import React from "react";
import { Container, Grid, Box, Typography } from "@mui/material";
import { CardIcon } from "../constant";
import { styled } from "@mui/material/styles";

const MainContainer = styled(Box)(({ theme }) => ({
  background: "#000",
  display: "flex",
  flexDirection: "column",
  padding: "60px 24px",
  position: "relative",
  overflow: "hidden",
  width: "100%",
  margin: "0 auto",

  "&::after": {
    content: '""',
    position: "absolute",
    width: "95%",
    height: "80%",
    left: "65%",
    top: "10%",
    bottom: "10%",
    transform: "translateX(-100%), translateY(-50%)",
    background:
      "radial-gradient(circle, rgba(99, 102, 241, 0.65) 0%, rgba(99, 102, 241, 0) 70%)",
    filter: "blur(100px)",
    //backdropFilter: "blur(500px)",
    zIndex: 0,
  },
}));

const ContentContainer = styled(Box)(({ theme }) => ({
  width: "100%", // Set to 95% width
  maxWidth: "1200px",
  margin: "0 auto",
  position: "relative",
  zIndex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  [theme.breakpoints.up("sm")]: {
    width: "97%",
  },
}));

const CardsBox = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "100%",
  margin: "0 auto",
  position: "relative",
  zIndex: 1,
  right: 'auto',
  left: 'auto',
  marginTop: theme.spacing(4),
  [theme.breakpoints.up("md")]: {
    marginTop: theme.spacing(6),
  },
  [theme.breakpoints.up("sm")]: {
    marginTop: theme.spacing(6),
    right: 'auto',
    left: 'auto',
  },
}));



const CardsCrausal = ({ title, subTitle, cardData }) => {

  return (
    <MainContainer>
      <ContentContainer>
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          width="100%"
          textAlign="center"
        >
          <Typography
            variant="h2"
            sx={{
              background: "linear-gradient(135deg, #6366F1 0%, #3B82F6 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: { xs: "24px", sm: "32px", md: "40px" },
              fontWeight: 700,
              mb: 2,
              textAlign: "center",
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              color: "#8C8CC2",
              fontSize: { xs: "14px", md: "18px" },
              lineHeight: 1.8,
              textAlign: "center",
              marginTop: 2,
              marginBottom: { sx: 2, md: 4 },
            }}
          >
            {subTitle}
          </Typography>
        </Box>
        <CardsBox>
          <Grid container spacing={1.2} justifyContent="center">
            {cardData?.map((card, index) => (
              <Grid item xs={12} sm={12} md={4} key={index}>
                <Box className="industrie-action-card">
                  <Box className="industrie-card-body">
                    <Box className="image-placeholder">
                      <Typography
                        variant="h4"
                        className="intro-text"
                      >
                        <Box
                          component="span"
                          sx={{
                            fontSize: "70px",
                            lineHeight: 1,
                            display: "block",
                            mb: 1.5,
                          }}
                        >
                          {index === 0
                            ? "🛡️"
                            : index === 1
                              ? "🌿"
                              : "👷"}
                        </Box>

                        {card.title}
                      </Typography>
                      {/* <img src={CardIcon} sx={{ width: "80px", height: "80px" }} /> */}

                    </Box>
                    <Box className="info">
                      <Typography variant="h5">{card.title}</Typography>
                      <Typography>{card.description}</Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </CardsBox>
      </ContentContainer>
    </MainContainer>
  );
};

export default CardsCrausal;
